export default __webpack_public_path__ + "static/media/share.6dca31e1.svg";